<template>
  <main class="page-operative page-operative-dashboard">
    <div class="container-fluid">
      <div class="d-flex align-items-start justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Dashboard Progetti</PageTitle>
      </div>

      <LoadingDataLoader v-if="isLoadingData" />
      <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData" />
      <div v-else-if="widgets" class="row report-texts-size">
        <div class="col-12 col-md-8 mb-4">
          <h3>Andamento nei prossimi 6 mesi</h3>
          Grafico del numero di progetti in un certo stato nei prossimi 6 mesi
        </div>

        <div class="col-12 col-md-4 mb-4">
          <h3>Andamento per stato</h3>
          Sparklines per previsti, approvati, in corso, terminati
        </div>

        <div class="col-12 mb-4">
          <h3>Tabella valori mese per mese</h3>
          Tabella esplosa con valori (ricavi, m1, m2, costi diretti, costi di struttura) mese per mese. 6 mesi precedenti + 6 mesi successivi.
        </div>

        <div class="col-12 col-md-4 mb-4">
          <h3>Recap 2020</h3>

          <p>Ricavi: 25000</p>
          <p>Costi: 15000</p>
          <p>M1 totale: 10000</p>
          <p>M1 medio: 3000</p>
          <p>M2 totale: 6000</p>
          <p>M2 medio: 1500</p>
        </div>

        <div class="col-12 col-md-4 mb-4">
          <h3>Recap 2021</h3>

          <p>Ricavi: 25000</p>
          <p>Costi: 15000</p>
          <p>M1 totale: 10000</p>
          <p>M1 medio: 3000</p>
          <p>M2 totale: 6000</p>
          <p>M2 medio: 1500</p>
        </div>

        <div class="col-12 col-md-4 mb-4">
          <h3>Recap 2022</h3>

          <p>Ricavi: 25000</p>
          <p>Costi: 15000</p>
          <p>M1 totale: 10000</p>
          <p>M1 medio: 3000</p>
          <p>M2 totale: 6000</p>
          <p>M2 medio: 1500</p>
        </div>

        <div class="col-12 col-md-4">
          <h3>Progetti accettati</h3>

          <p>Ricavi complessivi: </p>
          <p>Costi complessivi: </p>
          <p>M1 complessivo: </p>
          <p>M2 complessivo: </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';
import loadingDataMixin from '@/mixins/loadingData';

export default {
  name: 'page-operative-company-dashboard',
  mixins: [operativePageMixin, loadingDataMixin],
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('../../../components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('../../../components/Operative/LoadingDataLoader'),
  },
  data () {
    return {
      widgets: null,
    };
  },
  methods: {
    retrieveData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();

      this.$api.getProjectDashboard(this.company?.id)
        .then(res => {
          this.widgets = res?.data?.widgets || {};
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
  },
  watch: {
    company () {
      this.retrieveData();
    },
  },
};

</script>
